{
    "1": { "x": 0, "y": 0, "width": 320, "height": 320, "mask": true },
    "2": { "x": 320, "y": 0, "width": 320, "height": 320, "mask": true },
    "3": { "x": 640, "y": 0, "width": 320, "height": 320, "mask": true },
    "4": { "x": 0, "y": 320, "width": 320, "height": 320, "mask": true },
    "5": { "x": 320, "y": 320, "width": 320, "height": 320, "mask": true },
    "6": { "x": 640, "y": 320, "width": 320, "height": 320, "mask": true },
    "7": { "x": 0, "y": 640, "width": 320, "height": 331, "mask": true },
    "8": { "x": 320, "y": 640, "width": 320, "height": 320, "mask": true },
    "9": { "x": 640, "y": 640, "width": 320, "height": 320, "mask": true },
    "10": { "x": 0, "y": 971, "width": 320, "height": 320, "mask": true }
}
